import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import store, { persistor } from "./store/store";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter } from "react-router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LoadingProvider } from "./contexts/LoadingContext";
import { CategoriesProvider } from "./contexts/CategoriesContext";
import ErrorBoundary from "./components/ErrorBoundary";
import Config from "./utils/Config";

try {
  const legacy = localStorage.getItem("infoboxx-token");
  if (legacy && !localStorage.getItem(Config.TOKEN_KEY)) {
    localStorage.setItem(Config.TOKEN_KEY, legacy);
    localStorage.removeItem("infoboxx-token");
  }
  localStorage.removeItem("infoboxx_consumer_theme");
  document.documentElement.classList.remove("dark");
  delete document.documentElement.dataset.theme;
} catch {
  /* ignore */
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <PersistGate
          loading={null}
          persistor={persistor}
          onBeforeLift={() => {
            try {
              const token = store.getState().infoboxx_consumer?.token;
              if (token) localStorage.setItem(Config.TOKEN_KEY, String(token));
            } catch {
              /* ignore */
            }
          }}
        >
          <LoadingProvider>
            <BrowserRouter>
              <CategoriesProvider>
                <App />
              </CategoriesProvider>
              <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
            </BrowserRouter>
          </LoadingProvider>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);
